import VTable from '@/components/VTable/index.vue'

import {
  dfsFn,
  copyCells,
  paste,
  tranBoolean,
  filterTable,
  setRecordsSerialNumber,
  cellIsObject,
  createWatchableMap,
  MAXNUM,
  strNumAdd,
  handleImport
} from '@/utils/index'

const tableMixin = {
  components: { VTable },
  data() {
    return {
      contextMenuMap: {}, // 右键菜单
      tableData: [], // 表格数据缓存
      selectedRows: {}, // 选中的行
      modifyData: null, // 修改的行数据

      copyData: [], // 复制本表的内容  复制选中的行
      copyRows: [], // 复制选中的行
      locationCell: [0, 1]
    }
  },

  created() {
    // 在组件创建时初始化可监听的 Map
    this.modifyData = createWatchableMap(this.onModifyDataChange)
  },
  computed: {
    // 表格实例对象
    vtable() {
      return this.$refs.vtableRef?.tableInstance
    },
    // 是否有过滤数据
    hasActiveFilter() {
      return this.vtable?.records !== this.tableData
    },
    columnsFlat() {
      const arr = []
      dfsFn(
        this.columns,
        item => !item.columns?.length && arr.push(item),
        'columns'
      )
      return arr
    },
    tableData2IMap() {
      const map = {}
      dfsFn(this.tableData, item => {
        if (item.id) map[item.id] = item
      })
      return map
    }
  },
  methods: {
    initialized(col = 0, row = 1) {
      // 监听渲染结束事件
      this.locationCell = [col, row]
      this.vtable.on('after_render', this.renderAfter)
    },

    renderAfter() {
      if (!this.tableData?.length) return
      this.vtable.selectCell(...this.locationCell)
      this.vtable.off('after_render', this.renderAfter)
    },

    /**
     * 处理 modifyData 变化的回调函数
     * 可以在组件中重写此方法来自定义处理逻辑
     * @param {String} action - 操作类型：'set', 'delete', 'clear'
     * @param {*} key - 操作的键
     * @param {*} value - 新值
     * @param {*} oldValue - 旧值
     */
    onModifyDataChange(action, key, value, oldValue) {
      // 默认处理逻辑，子组件可以重写
      // switch (action) {
      //   case 'set':
      //     console.log('数据被修改:', key)
      //     break
      //   case 'delete':
      //     console.log('数据被删除:', key)
      //     break
      //   case 'clear':
      //     console.log('所有修改数据被清空')
      //     break
      // }
    },
    /**
     * 获取列配置信息
     * @param {Object} args - 事件参数
     * @returns {Object} 列配置对象
     */
    getColumnConfig(args) {
      // 从组件的columns配置中查找
      const column = this.columnsFlat.find(col => col.field === args.field)

      // 也可以从VTable实例获取列定义
      let vtableColumn = null
      if (this.vtable) {
        try {
          vtableColumn = this.vtable.getBodyColumnDefine(args.col, args.row)
        } catch (error) {
          console.warn('获取VTable列定义失败:', error)
        }
      }

      return {
        customConfig: column, // 你的自定义列配置
        vtableConfig: vtableColumn, // VTable的列配置
        isDisabled: !column?.canEdit || vtableColumn?.disable,
        field: args.field,
        title: column?.title || vtableColumn?.title
      }
    },

    // 获取已选中的数据  body中的
    getSelectData() {
      const selectedCellInfos = this.vtable.getSelectedCellInfos()
      return selectedCellInfos.filter(e => !!e[0].originData)
    },

    handleRowSelect() { },

    // 单元格失去编辑状态
    handleCellEdit(res) {
      const arr = ['_checkbox']
      res
        .filter(
          e =>
            !arr.includes(this.vtable.getBodyColumnDefine(e.col, e.row).field)
        )
        .forEach(e => this.modifyData.set(e.record, e.record))
    },

    // 非编辑状态的双击事件
    handleDblclick(args) {
      this.$emit('cell-dblclick', args)
    },

    // 删除
    handleBackspace() {
      const rows = this.getSelectData()
      for (const cells of rows) {
        cells.forEach(e => {
          if (this.clearCell(e)) {
            this.modifyData.set(e.originData, e.originData)
          }
        })
      }
    },

    clearCell(cell) {
      const column = this.getColumnConfig(cell)
      if (!column.customConfig.canModify) return false
      cell.originData[cell.field] = null
      if (cell.field.endsWith('Name')) {
        cell.originData[cell.field.replace('Name', 'Id')] = null
      }
      this.$refs.vtableRef.handleFieldCalculation(
        cell.field,
        cell.originData[cell.field],
        cell.originData,
        cell.row,
        cell.col
      )
      // const idKey = cellIsObject(cell)
      // if (idKey) cell.originData[idKey] = null

      return true
    },

    // 右键查询
    handleSearch() {
      this.$filterFieldModal({
        columns: this.columnsFlat,
        confirm: arr => {
          const filterForm = {}
          arr.forEach(item => (filterForm[item.key] = item.value || undefined))
          this.vtable.updateFilterRules([
            {
              filterFunc(record) {
                return filterTable(record, filterForm)
              }
            }
          ])
        }
      })
    },

    // 批量修改一列多个单元格的数据
    async handleEdit() {
      const selectedCellInfos = this.vtable.getSelectedCellInfos()
      if (selectedCellInfos.length === 0) {
        return this.$message.warning('请先选中要编辑的单元格！')
      }
      const customConfig = this.getColumnConfig(
        selectedCellInfos[0][0]
      )?.customConfig
      if (customConfig.field === 'operation')
        return this.$message.warning('请先选中要编辑的单元格！')

      if (typeof customConfig.handleEdit === 'function') {
        customConfig.handleEdit.call(this, selectedCellInfos)
        return
      }
      let editModal = customConfig?.editModal || {}
      let options = editModal.options
      if (typeof options === 'function') {
        options = await options.call(this)
      }
      this.$selectModal({
        title: editModal.title || customConfig.title,
        columns: editModal.columns,
        width: editModal.width,
        type:
          (customConfig.editor?.type &&
            !['textarea', 'date'].includes(customConfig.editor?.type)) ||
            editModal.columns
            ? ''
            : customConfig.editor?.type ||
            customConfig.cellType ||
            customConfig.fieldType ||
            'input',
        scale: customConfig.scale,
        options: options,
        allowMultiSelect: editModal.allowMultiSelect || false,
        confirm: (res, tableData) => {
          if (editModal.confirm) {
            editModal.confirm.call(
              this,
              selectedCellInfos.filter(e => e[0].row > 0),
              res,
              tableData
            )
          } else {
            selectedCellInfos.forEach(cells => {
              const obj = cells[0].originData
              this.$set(obj, customConfig.field, res)
              this.$refs.vtableRef.handleFieldCalculation(
                customConfig.field,
                res,
                obj,
                cells[0].row,
                cells[0].col
              )
            })
          }

          selectedCellInfos.forEach(e =>
            this.modifyData.set(e[0].originData, e[0].originData)
          )
        }
      })
    },

    getModifyData() {
      return [...this.modifyData.values()]
    },
    cleanModifyData() {
      this.modifyData.clear()
    },
    setModifyData(list) {
      const rows = list.map(e => e[0].originData)
      rows.forEach(e => this.modifyData.set(e, e))
    },

    // 删除多行
    handleDelete(records) {
      if (records?.length) {
        // 有传入的数据  说明不需要确认直接删除
        records.forEach(e => {
          e[0].originData.deleteFlag = 1
          this.modifyData.set(e[0].originData, e[0].originData)
        })

        this.vtable.deleteRecords(
          records.map(
            e => this.vtable.getBodyIndexByTableIndex(e[0].col, e[0].row).row
          )
        )
      } else {
        const rows = this.vtable
          .getSelectedCellInfos()
          .filter(e => e[0].originData)
        if (!rows.length) return this.$message.warning('请先选中要删除的行！')
        // 确认是否要删除
        this.$confirm('确认删除选中项吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(async () => {
            const arr = rows.map(e => e[0].originData)
            if (arr[0].businessId && arr[0].path && arr[0].size) {
              const res = await this.$service.post(
                '/business-file/batch/delete',
                arr.map(e => e.id)
              )
              if (res.code === 200) {
                this.$message.success('删除成功')
                const list = rows.map(e =>
                  this.vtable.getRecordIndexByCell(e[0].col, e[0].row)
                )
                this.vtable.deleteRecords(list)
              } else {
                this.$message.error(res.message)
              }
            } else {
              dfsFn(arr, e => {
                e.deleteFlag = 1
                this.modifyData.set(e, e)
              })
              const list = rows.map(e =>
                this.vtable.getRecordIndexByCell(e[0].col, e[0].row)
              )
              this.vtable.deleteRecords(list)
              const selectCellInfos = this.vtable.getSelectedCellInfos()
              this.$emit('row-select', selectCellInfos)
            }
          })
          .catch(() => { })
      }
    },

    // 复制整个表格
    // handleCopyTable() {
    //   const rows = this.getSelectData()
    //   this.copyData = rows.map(e => ({
    //     ...e[0].originData,
    //     children: null,
    //     id: null
    //   }))
    // },

    // 拷贝本表+子表
    handleCopyTableChild() {
      const rows = this.getSelectData()
      if (rows?.length !== 1) return this.$message.warning('请选中一条数据！')
      this.copyData = rows.map(e => ({ ...e[0].originData }))
      this.$message.success('复制成功！')
    },

    // 复制选中的单元格
    handleCopyCell() {
      copyCells(this.vtable)
    },

    // 插入一条数据
    handleInsert(newRecords, insertIndex) {
      if (!newRecords) newRecords = [{}]
      let targetRecord
      if (insertIndex === undefined && this.tableData.length) {
        const rows = this.getSelectData()
        if (rows.length) {
          insertIndex = rows[0][0].row
        } else {
          const cells = this.vtable.getAllBodyCells()
          insertIndex = cells.find(
            e => e[0].originData === this.tableData[this.tableData.length - 1]
          )[0].row
        }
      }

      targetRecord = this.vtable.getRecordByCell(0, insertIndex)

      // 插入需要插入到同级的后面 如果有父级，绑定父级
      if (targetRecord?.parentId) {
        newRecords.forEach(e => (e.parentId = targetRecord?.parentId))
      }
      // 找到父级的children，然后插入数据
      const parentRecord = this.tableData2IMap[targetRecord?.parentId]
      let children = parentRecord?.children
      if (!children) children = this.tableData

      // 设置orderNum
      const index = children.findIndex(e => e.id === targetRecord?.id)
      if (children.length - 1 === index) {
        // 最后添加
        newRecords.forEach(
          (e, i) =>
            (e.orderNum = Math.floor(
              strNumAdd(targetRecord?.orderNum, i + 1)
            )) + ''
        )
        if (this.handleInsertBefore) {
          this.handleInsertBefore(newRecords, insertIndex)
        }
        children.push(...newRecords)
      } else {
        // 中间添加
        setRecordsSerialNumber(
          newRecords,
          children[index]?.orderNum || '0',
          children[index + 1]?.orderNum || '0'
        )
        if (this.handleInsertBefore) {
          this.handleInsertBefore(newRecords, insertIndex)
        }
        children.splice(index + 1, 0, ...newRecords)
      }

      // 上面已经在tableData里面添加了  还需要在vtable里面添加
      let indexs = this.vtable.getRecordIndexByCell(0, insertIndex)
      if (!Array.isArray(indexs)) indexs = [indexs]
      indexs[indexs.length - 1]++
      // this.vtable.addRecords(newRecords, indexs)
      newRecords.forEach(e => this.modifyData.set(e, e))
    },

    // 插入下级
    handleInsertChild(newRecords, insertIndex) {
      if (!newRecords) newRecords = [{}]
      const rows = this.getSelectData()
      if (!rows.length) {
        this.handleInsert()
        return
      }
      if (insertIndex === undefined) insertIndex = this.getBodyIndex()

      // 当前选中行就是父节点
      const parentRecord = this.vtable.getRecordByCell(0, insertIndex)
      newRecords.forEach(e => (e.parentId = parentRecord?.id))
      if (!parentRecord.children) this.$set(parentRecord, 'children', [])
      const children = parentRecord.children
      // 最后一个子节点，排序增加
      const lastRecord = children[children.length - 1]
      if (!lastRecord) {
        newRecords.forEach((e, i) => (e.orderNum = i + 1 + ''))
      } else {
        newRecords.forEach(
          (e, i) =>
            Math.floor((e.orderNum = strNumAdd(lastRecord.orderNum, i + 1))) +
            ''
        )
      }
      // 添加进tableData
      children.push(...newRecords)
      newRecords.forEach(e => this.modifyData.set(e, e))
    },

    // 获取需要插入的行数 单元格在body的第几行  也是tableData的第几个
    getBodyIndex(isFirst = true) {
      const rows = this.getSelectData()
      // 在body中的第几个  有些有多级表头
      if (!rows?.length) return this.tableData.length
      const { col, row } = rows[isFirst ? 0 : rows.length - 1][0]
      const record = this.vtable.getBodyIndexByTableIndex(col, row)
      return record.row + 1
    },

    //拷贝行
    handleCopyRow() {
      const rows = this.getSelectData()
      if (rows?.length === 0) return this.$message.warning('请选中一条数据！')
      this.copyRows = rows.map(e => ({
        ...e[0].originData,
        id: null,
        orderNum: null
      }))
      this.$message.success('复制成功！')
    },

    // 插入拷贝行
    handleInsertCopyRow() {
      if (this.copyRows.length === 0)
        return this.$message.warning('请先拷贝行数据！')

      const insertIndex = this.getBodyIndex(false)

      this.handleInsert(
        this.copyRows.map(e => ({ ...e })),
        insertIndex
      )
    },

    // 插入本表+子表
    async handleInsertTableChild() {
      if (this.copyData.length === 0)
        return this.$message.warning('请先复制数据！')

      const insertIndex = this.getBodyIndex(false)

      this.handleInsert(
        this.copyData.map(e => ({ ...e })),
        insertIndex
      )
    },

    // 插入剪切板内容
    async handleInsertCopyCell() {
      const res = await paste()
      const arr = res
        .split('\n')
        .map(e => e.split('\t'))
        .map(list =>
          list.map(e => {
            if (e === 'true') return true
            if (e === 'false') return false
            return e
          })
        )
      const content = arr.map(e => {
        const obj = {}
        this.columnsFlat.forEach((item, index) => {
          if (item.cellType === 'checkbox') {
            const bol = tranBoolean(e[index])
            if (typeof bol === 'boolean') obj[item.field] = bol
          } else if (item.field?.endsWith('Name')) {
            obj[item.field] = ''
          } else {
            obj[item.field] = e[index]
          }
          obj.projectId = this.projectId
        })
        return obj
      })

      const insertIndex = this.getBodyIndex(false)
      this.handleInsert(content, insertIndex)
    },

    // 粘贴单元格
    async handlePasteCell() {
      const res = await paste()
      const arr = res.split('\n').map(e => e.split('\t'))
      const content = arr.map(e => {
        const obj = {}
        this.columnsFlat.forEach((item, index) => {
          if (e[index] !== undefined) {
            if (item.cellType === 'checkbox') {
              const bol = tranBoolean(e[index])
              if (typeof bol === 'boolean') obj[item.field] = bol
            } else if (item.field?.endsWith('Name')) {
              obj[item.field] = ''
              obj[item.field.replace(/Name$/, 'Id')] = ''
            } else {
              obj[item.field] = e[index]
            }
          }
        })
        return obj
      })
      const insertIndex = this.getBodyIndex(false) - 1

      for (let i = 0; i < content.length; i++) {
        const obj = this.tableData[insertIndex + i]
        Object.assign(obj, content[i])
        this.modifyData.set(obj, obj)
      }
    },

    handleExport() {
      this.vtable.exportToExcel()
    },

    async handleUpload() {
      const { id = '', accept = '', uploadAfter } = this.uploadParams || {}
      if (!id) return this.$message.warning('请先选中目标数据！')
      const res = await handleImport({ vm: this, id, accept })
      if (typeof uploadAfter === 'function') await uploadAfter(res)
    }
  }
}

export { tableMixin }
